import { api } from './client';
import { authResponseSchema, otpRequestSchema, profileSchema } from './types';

/** Request an email OTP. Returns devCode (non-null) only in dev/stub mode. */
export function otpRequest(email: string) {
  return api.post('/auth/otp/request', otpRequestSchema, { email });
}

/** Verify the OTP and log in (or register) by email → { token, player }. */
export function otpVerify(email: string, code: string) {
  return api.post('/auth/otp/verify', authResponseSchema, { email, code });
}

/** Telegram Login Widget callback → { token, player }. */
export function telegramLogin(params: Record<string, unknown>) {
  return api.post('/auth/telegram-login', authResponseSchema, params);
}

/** Accept the public offer (authenticated) → refreshed profile. */
export function acceptTerms() {
  return api.post('/me/terms', profileSchema);
}

/** Завершить онбординг нового игрока (сохраняет «откуда узнали») → профиль. */
export function completeOnboarding(referralNote: string | null) {
  return api.post('/me/onboarding', profileSchema, referralNote ? { referralNote } : {});
}
